import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';
import { useReportTableDataGridStore, initialReportColumns } from '@store';

type ReportColumnKey =
  'name' | 'description' | 'folder_name' | 'organisation' | 'created_at';

const REPORT_TABLE_COLUMN_LABELS: Record<ReportColumnKey, string> = {
  name: 'Name',
  description: 'Description',
  folder_name: 'Folder',
  organisation: 'Organization',
  created_at: 'Created at',
};

const ALL_FIELDS = initialReportColumns
  .map(c => c.field)
  .filter(
    f => f !== 'favorite' && f !== 'private' && f !== 'action',
  ) as ReportColumnKey[];

export const ReportTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useReportTableDataGridStore(s => s.hiddenColumns);
  const setHiddenColumns = useReportTableDataGridStore(s => s.setHiddenColumns);

  const columns: Partial<Record<ReportColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<ReportColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  const handleReset = () => {
    setHiddenColumns([]);
  };

  return (
    <ColumnSelectionFilter
      name='report_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={REPORT_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={handleReset}>
          RESET
        </Button>
      }
    />
  );
};
